import { deserializeMaritalInformation } from './deserialize-marital-information';
import { serializeMaritalInformation } from './serialize-marital-information';
import {
  MaritalInformationFormT, MaritalInformationRequestT, MartialInformationResponseT,
} from '../../types';
import { TransformT } from '../../types/transform';

export const maritalInformationTransform: TransformT<
  MaritalInformationFormT,
  MartialInformationResponseT,
  MaritalInformationRequestT
> = {
  deserialize: deserializeMaritalInformation,
  serialize: serializeMaritalInformation,
};
